import { PS, T } from '../lib/theme';

interface Props {
  value: string;        // YYYY-MM-DD
  onChange: (next: string) => void;
  min?: string;
  max?: string;
  ariaLabel?: string;
}

/**
 * Thin wrapper over <input type="date">. The browser's native picker is
 * good enough for an internal tool; no need for a JS calendar component.
 */
export function DatePicker({ value, onChange, min, max, ariaLabel }: Props) {
  return (
    <input
      type="date"
      value={value}
      min={min}
      max={max}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value)}
      style={{
        padding: '8px 10px',
        border: `1px solid ${PS.border}`,
        borderRadius: 3,
        background: PS.white,
        minHeight: 40,
        ...T.ui,
        color: PS.nearBlack,
      }}
    />
  );
}
